import {Component, inject} from '@angular/core'
import {MatIcon} from '@angular/material/icon'
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu'
import {LogoComponent, ToggleButtonComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import {MatIconButton} from '@angular/material/button'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {environment} from '../../../environments/environment'
import {RoleHelperService} from '../../services/role-helper.service'
import {RouterLink} from '@angular/router'

@Component({
  selector: 'spb-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    LogoComponent,
    MatIconButton,
    ToggleButtonComponent,
    RouterLink
  ]
})
export class HeaderComponent {
  protected readonly service = inject(ConfigService)
  protected readonly roleHelper = inject(RoleHelperService)
  protected readonly environment = environment
}
